import axios from "axios";
import { storage } from "./storage";

export const api = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL + "api/",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

// Request interceptor: Automatically attach Authorization header if token exists
api.interceptors.request.use(
  (config) => {
    const token = storage.getToken();
    if (token) {
      config.headers.Authorization = `token ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor: Handle 401 errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      if (document) document.cookie = "";
    }
    return Promise.reject(error);
  }
);
